import { css, CSSObject, keyframes } from '@emotion/react';

const rotate = keyframes`
  from { 
    transform: rotate(0); 
  }
  to { 
    transform: rotate(360deg); 
  }
`;

const background: CSSObject = {
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  background: 'rgba(0, 0, 0, 0.7)',
  zIndex: 999,
};

const wrap = css`
  width: 50px;
  height: 50px;
  border: 3px solid rgba(253, 92, 43, 0.3);
  border-radius: 50%;
  border-top-color: rgba(253, 92, 43, 1);
  animation: ${rotate} 0.8s linear infinite;
`;

export { background, wrap };
